import React from 'react';
import { Card, Col, Row } from "antd";

interface ElementProps {
    element: Object;
}

const PlantillaLista: React.FC<ElementProps> = ({ element }) => {
    return (
        <Card bordered={true}>
            <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', alignContent: 'flex-start', width: '100%' }}>
                {Object.entries(element).map(([key, value]) => {
                    if (Array.isArray(value)) {
                        // Ignorar si el valor es un array
                        return null;
                    }
                    return (
                        <div key={key} style={{ marginBottom: '10px', width: '50%' }}>
                            <Row gutter={16}>
                                <Col className="gutter-row" span={12}>
                                    <Row gutter={16}>
                                        <Col className="gutter-row">
                                            <b>{key}</b>
                                        </Col>
                                        <Col className="gutter-row">
                                            <div>{value}</div>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </div>
                    );
                })}
            </div>
        </Card>
    );
};

export default PlantillaLista;
